export const translations = {
  de: {
    'plugin-translator': {
      buttonLabel: 'Übersetzen',
      errorMessage: 'Beim Versuch, die Daten zu übersetzen, ist ein Fehler aufgetreten',
      modalDescription:
        'Die Felder des Dokuments in der Quellsprache werden übersetzt und in die entsprechenden Felder der aktuell geöffneten Sprache eingefügt.',
      modalSourceLanguage: 'Quellsprache',
      modalTitle: 'Felder aus anderer Sprache übersetzen',
      modalTranslating: 'Felder werden übersetzt...',
      submitButtonLabelEmpty: 'Nur leere Felder übersetzen',
      submitButtonLabelFull: 'Alle Felder übersetzen',
      successMessage:
        'Erfolgreich übersetzt. Drücken Sie "Speichern", um die Änderungen anzuwenden.',
    },
  },
  en: {
    'plugin-translator': {
      buttonLabel: 'Translate',
      errorMessage: 'An error occurred when trying to translate the data',
      modalDescription:
        'The fields of the document in the source language are translated and inserted into the corresponding fields of the currently opened language.',
      modalSourceLanguage: 'Source language',
      modalTitle: 'Translate fields from another language',
      modalTranslating: 'Fields are being translated...',
      submitButtonLabelEmpty: 'Translate only empty fields',
      submitButtonLabelFull: 'Translate all fields',
      successMessage: 'Successfully translated. Press "Save" to apply the changes.',
    },
  },
}
